<template>
    <b-button v-if="!hideLabel" icon-left="calendar" @click="downloadCalendar" class="button is-success">
      {{ label }}
    </b-button>
    <b-tooltip v-else class="control is-success" :label="label" position="is-bottom"
      multilined>
      <b-button icon-left="calendar" @click="downloadCalendar" class="button is-success">
    </b-button>
    </b-tooltip>
</template>

<script>
import ApiService from '../_api/api.service'
import dateSettings from '@/_helpers/date.config'
import DateFilter from '@/_helpers/date.filter'

export default {
  props: {
    answerSetId: {
      type: Number,
      required: true
    },
    hideLabel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      calendarData: null,
      isCompany: false,
      label: 'Aksiyon Takvimini İndir',
      dateSettings
    }
  },
  methods: {
    async loadData() {
      if (this.calendarData) return

      this.calendarData = await ApiService.get(`/answerset/${this.answerSetId}/actionTrackingCalendarData`)
    },
    async downloadCalendar() {
      await this.loadData()
      const { ics, filename } = this.generateICS()
      if (ics) {
        this.downloadFile(ics, filename)
      } else {
        console.error('ICS content is empty.')
      }
    },
    generateICS() {
      if (this.calendarData.noAction === true || this.calendarData.answers.length < 1) {
        this.$buefy.toast.open({
          message: 'Bu denetimde aksiyon takibi bulunmamaktadır.',
          type: 'is-warning'
        })
        return
      }
      const data = this.calendarData
      let ics = 'BEGIN:VCALENDAR\nVERSION:2.0\n'
      const deliveryDateHour = 9
      const gmt = (new Date().getTimezoneOffset() / 60) * -1
      const currentDate = new Date()
      const submitDate = new Date(data.submitDate)
      const submitMonth = dateSettings.monthNames[submitDate.getMonth()]
      const submitYear = submitDate.getFullYear()

      for (const answer of data.answers) {
        const deliveryDate = new Date(answer.actionDeliveryDate)
        const startDate = new Date(deliveryDate.getFullYear(), deliveryDate.getMonth(), deliveryDate.getDate(), deliveryDateHour)
        const endDate = new Date(startDate.setHours(deliveryDateHour))

        const actionAssignors = answer.actionAssignors.replaceAll(' ', '').split(',').join(';').split(';')
        const assignorEmails = actionAssignors.filter(assignor => assignor.includes('@'))

        const eventTitle = `${answer.isCanceled ? '[İPTAL]' : ''}Aksiyon Takip: ${answer.actionTitle} - ${data.process.name} - ${submitMonth}/${submitYear} - Soru#${answer.question.no}`
        const uidPrefix = data.user.companyId ? `c${data.user.companyId}` : `p${data.userId}`
        const uid = `${uidPrefix}_${data.processId}_${answer.questionId}`
        var sequence = answer.isCanceled ? parseInt(answer.id) + 1 : parseInt(answer.id)
        ics +=
`BEGIN:VEVENT
UID:${uid}
SEQUENCE:${sequence}
SUMMARY: ${eventTitle}
DESCRIPTION:Denetim Tarihi: ${DateFilter.date(submitDate)}\\n\\nKontrol Sorusu: ${answer.question.name} ${answer.question.description ? '(' + answer.question.description + ')' : ''}\\n\\nAksiyon Tanımı: ${answer.actionTitle}\\n\\nAçıklama:${answer.description}\\n\\nAtanan Kisiler:${answer.actionAssignors}
DTSTART;TZID=Europe/Istanbul:${new Date(startDate.setHours(startDate.getHours() + gmt)).toISOString().replace(/\.\d{3}Z$/, '').replace(/[-:]/g, '')}
DTEND;TZID=Europe/Istanbul:${new Date(endDate.setHours(endDate.getHours() + gmt)).toISOString().replace(/\.\d{3}Z$/, '').replace(/[-:]/g, '')}
CREATED;TZID=Europe/Istanbul:${new Date(submitDate.setHours(endDate.getHours() + gmt)).toISOString().replace(/\.\d{3}Z$/, '').replace(/[-:]/g, '')}
ORGANIZER:mailto:${data.user.email}\n`

        if (answer.isCanceled) {
          ics += 'STATUS:CANCELLED\n'
        } else {
          ics += 'STATUS:TENTATIVE\n'
        }

        assignorEmails.forEach(assignorEmail => {
          ics += `ATTENDEE;ROLE=REQ-PARTICIPANT;PARTSTAT=NEEDS-ACTION;RSVP=TRUE;CN=${assignorEmail.trim()}:mailto:${assignorEmail.trim()}\n`
        })

        var dayCountToDeliveryDate = this._daysBetween(deliveryDate, currentDate)
        var dayCountSecondAlarm = Math.ceil(dayCountToDeliveryDate / 2)

        if (dayCountToDeliveryDate >= 15 && !answer.isCanceled) {
          ics +=
`BEGIN:VALARM
ACTION:DISPLAY
DESCRIPTION:Aksiyon Takip Hatirlatma: ${eventTitle}
TRIGGER:-P15D
END:VALARM\n`
        }

        if (dayCountSecondAlarm >= 1 && !answer.isCanceled) {
          ics +=
`BEGIN:VALARM
ACTION:DISPLAY
DESCRIPTION:Aksiyon Takip Hatirlatma: ${eventTitle}
TRIGGER:-P${dayCountSecondAlarm}D
END:VALARM\n`
        }

        ics += 'END:VEVENT\n'
      }

      ics += 'END:VCALENDAR'
      const filename = `${data.process.name} - ${submitMonth}-${submitYear}.ics`
      return { ics, filename }
    },
    downloadFile(content, filename) {
      const blob = new Blob([content], { type: 'text/calendar' })
      blob.name = filename
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    _daysBetween(date1, date2) {
      const oneDay = 24 * 60 * 60 * 1000
      const diffDays = Math.round(Math.abs((date1 - date2) / oneDay))
      return diffDays
    }
  }
}
</script>
